import requests from "./api/base-api";

const PrivacyPolicyService = {
  getPolicyByUser: (body) =>
    requests.get("/policy/v1/get-all-policy-by-user", body),
};

export default PrivacyPolicyService;
